exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-body[data-v-1ca90a82]{background:#f0f0f0;max-width:100%;min-height:100vh}.table-title[data-v-1ca90a82]{font-size:1.25rem;color:#333;font-weight:500;margin-top:16px;margin-bottom:8px}.link-btn[data-v-1ca90a82]{font-size:12px;font-weight:400}", ""]);

// exports
